import { Bars3BottomLeftIcon } from '@heroicons/react/24/outline';
import { t } from 'i18next';
import logoIcon from '../../../assets/logo-icon.png';
import { I18N_MOBILE_HEADER } from '../constants';

const buttonClass =
  'flex items-center border-spark-border-subtle border-r px-5 text-spark-text-secondary focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-spark-accent-hover focus-visible:ring-inset';

export function MobileHeader({
  acronymTeamName,
  onToggleSidebar,
}: {
  acronymTeamName?: string;
  onToggleSidebar: () => void;
}) {
  return (
    <header className="relative lg:hidden">
      <div className="fixed inset-0 z-20 flex h-12 shrink-0 items-center justify-between border-spark-border-subtle border-b bg-spark-surface">
        {/* Mobile nav - Sidebar menu toggle, and SparkLayer icon */}
        <nav className="flex h-full">
          <button type="button" className={buttonClass} onClick={onToggleSidebar}>
            <span className="sr-only">{t(`${I18N_MOBILE_HEADER}.open_sidebar`)}</span>
            <Bars3BottomLeftIcon className="size-6" />
          </button>

          <a href="/" className={buttonClass}>
            <img className="h-6 w-auto" src={logoIcon} alt={t(`${I18N_MOBILE_HEADER}.logo_alt`)} />
          </a>
        </nav>

        {/* Right side of header */}
        <div className="relative z-10 ml-4 flex items-center md:ml-6">
          {/* Profile */}
          <div className="relative ml-3 pr-4">
            <div>
              <div className="flex max-w-xs items-center rounded-full bg-spark-surface text-sm focus:outline-hidden focus:ring-2 focus:ring-spark-accent-hover focus:ring-offset-2">
                <div className="flex size-7 items-center justify-center rounded-full bg-spark-purple font-medium text-white text-xs tracking-widest">
                  <span className="inline-block w-5 overflow-hidden text-center">
                    {acronymTeamName}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
